const state = {
  idToken: null,
  widget_theatre_id: null,
  isVkWidget: false,
  isVkMobileWidget: false,
  customer: {
    accounts: {},
    accountsList: [],
  },
  user: {
    isRegistrationInWidget: false,
    sessionEndAt: null,
    sessionId: null,
    socketSessionId: null,
    ticketOrderId: null,
    barOrderId: null,
    barOrderCode: null,
    transactionId: null,
    card: {
      number: null,
      balance: null,
      id: null,
    },
    maxBonuses: 0,
    email: null,
    name: null,
    phone: '',
    prepareOrderBefore: null,
    subscription: false,
    paymentType: 'Base',
    paymentWithBonuses: false, // Включена ли оплата бонусами (задается пользователем на странице оплаты)
    isAuthorized: false,
  },
  session: {
    DateTime: '',
  },
  theatre: {
    NameFull: '',
    SupportPhone: '',
  },
  places: [],
  rows: [],
  movie: {
    Genres: [],
  },
  bar: [],
  cart: {
    tickets: [],
    deletedTickets: [],
    bar: [],
    ticketSum: 0, // промежуточная стоимость всех билетов
    barSum: 0, // промежуточная стоимость всей продукции бара
    sum: 0, // сумма с учетом бонусов. Отправляется в платежную систему
    totalSum: 0, // общая сумма без учета бонусов
    usedBonuses: 0, // общее количество бонусов. Находится в сторе, чтоб восстановить значение после смена route
    spentBonuses: {
      bar: 0, // количество потраченных бонусов на бар
      tickets: 0, // количество потраченных бонусов на билеты
    },
    donations: '',
    promocode: '',
  },
  setting: {
    notification1Show: false,
    notification1Title: '',
    notification1Descr: '',
    notification1Only3d: false,
    notification1Image: '',
    notification2Show: false,
    notification2Title: '',
    notification2Descr: '',
    notification2Only3d: false,
    notification2Image: '',
    notification3Show: false,
    notification3Title: '',
    notification3Descr: '',
    notification3Only3d: false,
    notification3Image: '',
    currency: '₽',
    supportPhone: null,
    maxSeats: null,
    isBonusAvailable: false, // есть ли возможность оплаты бонусами. (Если есть апи ключ в админке)
    freePlaces: true,
    freeCostPlaces: true,
    paymentMethods: [],
    enabledPayments: [],
  },
  data: {
    cities: null,
    schedule: null,
    filmWithSchedule: {
      Theatres: [],
    },
    barForm: {
      selectCity: '',
      selectTheatre: '',
      selectTime: null,
      selectDate: null,
    },
    scheduleForm: {
      selectCity: '',
      selectTheatre: '',
      selectTime: null,
      selectDate: new Date(),
    },
    notifications: null,
  },
  loading: false,
  errors: [],
  orderId: null,
  promoData: null,
  orderInfo: null,
  isStartFromSchedule: false,
};

export default state;
